import { App } from '../work-modules/046/App';

export const main = async () => {
  const canvas = document.getElementById('webgl-canvas') as HTMLCanvasElement;
  const app = new App(canvas);
}

document.addEventListener('DOMContentLoaded', () => {
  main();
});
